import { ButtonKind, FauxButton } from "../../../../../../core/ui";

export function CoastUserNoSubscription() {
  return (
    <div className="component-account-subscription">
      <div className="content">
        <p>
          It seems like you don&apos;t have an active subscription. Please subscribe in order to access premium
          features.
        </p>
      </div>

      <FauxButton to="/sign-up/?step=subscription" className="account-button" kind={ButtonKind.SECONDARY}>
        Subscribe
      </FauxButton>
    </div>
  );
}
